// extracted by mini-css-extract-plugin
export default {"container":"cookie_container__H6xGx","item":"cookie_item__vgg6Q","subitem":"cookie_subitem__hVnI9","date":"cookie_date__6Qwtd","point":"cookie_point__IuyjK"};